import DTO from './DTO';
import PersonDTO from './PersonDTO';
import { ogrnIp15, required } from '../utils/validation';

class IndividualEntrepreneurDTO extends DTO {
  constructor(params, isValidInit) {
    const attr = new PersonDTO().getAttributes();
    const attributes = [
      ...attr,
      {
        name: 'ogrn',
        type: String,
        validators: [required, ogrnIp15],
        labelKey: 'ogrnip',
        couldBeNull: true,
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const personData = new PersonDTO().getData.call(this);
    const data = {
      ...personData,
      ogrnip: this.ogrnip,
    };
    return data;
  }
}

export default IndividualEntrepreneurDTO;
